import type { SVGProps } from 'react';

const SvgIsgPro = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="m13.71 13.71 2-2a.996.996 0 0 0 0-1.41l-2-2a.996.996 0 1 0-1.41 1.41l.29.29H9c-.55 0-1 .45-1 1s.45 1 1 1h3.59l-.29.29a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29z"
    />
    <path
      fill="currentcolor"
      d="M6 5h3.09c.4 0 .78.12 1.11.34l1.49.99c.66.44 1.43.67 2.22.67H18c.55 0 1 .45 1 1v6c0 .55.45 1 1 1s1-.45 1-1V8c0-1.65-1.35-3-3-3h-4.09c-.4 0-.78-.12-1.11-.34l-1.49-.99C10.65 3.23 9.88 3 9.09 3H6C4.35 3 3 4.35 3 6v10c0 1.07.57 2.06 1.5 2.6.16.09.33.13.5.13.35 0 .68-.18.87-.5.28-.48.11-1.09-.36-1.37-.31-.18-.5-.51-.5-.87V6c0-.55.45-1 1-1z"
    />
    <path
      fill="currentcolor"
      d="M11.34 15.13c-.28-.18-.58-.28-.9-.28H8.52a.61.61 0 0 0-.47.19c-.13.13-.19.28-.19.47v4.86c0 .18.06.34.17.47.12.13.27.2.46.2s.34-.07.46-.2a.65.65 0 0 0 .17-.47v-1.44h1.31c.32 0 .62-.09.9-.28a2.09 2.09 0 0 0 .92-1.76c0-.37-.09-.72-.25-1.03-.17-.31-.39-.55-.67-.73zm-.48 2.15c-.06.12-.13.23-.22.3-.07.06-.14.1-.21.1H9.12v-1.56h1.31q.105 0 .21.09c.08.07.16.17.22.29a.89.89 0 0 1 0 .78m4.01-1.07a1.6 1.6 0 0 0-.77.43.6.6 0 0 0-.14-.21c-.25-.25-.69-.26-.94 0-.12.13-.19.28-.19.47v3.47c0 .19.06.34.19.47.12.13.28.19.47.19s.35-.06.47-.19.19-.29.19-.47v-1.99c0-.18.02-.34.07-.47q.075-.195.18-.33c.08-.09.15-.15.24-.18.18-.08.35-.07.48-.01.23.1.53.11.76-.08.13-.11.2-.28.2-.51 0-.17-.08-.33-.23-.45-.25-.21-.62-.21-.98-.12zm5.95 1.14c-.22-.37-.51-.67-.88-.88-.73-.42-1.72-.42-2.46 0-.37.21-.66.51-.88.88s-.33.81-.33 1.29.11.92.33 1.29.51.67.88.88.78.31 1.23.31.86-.11 1.23-.31c.37-.21.66-.5.88-.87s.33-.81.33-1.29-.11-.92-.33-1.29zm-1.13 1.95a1.092 1.092 0 0 1-1.95 0q-.15-.285-.15-.66c0-.25.05-.49.15-.67.1-.19.24-.33.41-.44.17-.1.36-.15.56-.15s.4.05.57.15.31.25.41.44.15.41.15.67q0 .39-.15.66"
    />
  </svg>
);
export default SvgIsgPro;
